import { render, staticRenderFns } from "./RoleMaintain.vue?vue&type=template&id=550ebf62&scoped=true"
import script from "./RoleMaintain.vue?vue&type=script&lang=js"
export * from "./RoleMaintain.vue?vue&type=script&lang=js"
import style0 from "./RoleMaintain.vue?vue&type=style&index=0&id=550ebf62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ebf62",
  null
  
)

export default component.exports